import { Routes } from '@angular/router';

import { authGuard } from '@core/guards/auth.guard';
import { loginGuard } from '@core/guards/login.guard';
import { LoginComponent } from '@modules/login/login.component';
import { OverviewComponent } from '@modules/overview/overview.component';
import { RtuDataMapComponent } from '@modules/rtudata/rtudata-map.component';
import { UnauthorizedMenuComponent } from '@modules/unauthorized-menu/unauthorized-menu.component';

import { MapLayoutComponent } from './layouts/map-layout/map-layout.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'job',
  },
  {
    canActivate: [authGuard],
    component: MapLayoutComponent,
    data: { role: ['admin', 'manager', 'employee'] },
    loadChildren: () => import('@modules/job/jobs.routes'),
    path: 'job',
  },
  {
    canActivate: [authGuard],
    component: RtuDataMapComponent,
    data: { role: ['admin', 'manager'] },
    loadChildren: () => import('@modules/rtudata/rtudata.route'),
    path: 'greenhouse',
  },
  {
    canActivate: [authGuard],
    component: MapLayoutComponent,
    data: { role: ['admin', 'manager'] },
    loadChildren: () => import('@modules/seeding/seeding.route'),
    path: 'seeding',
  },
  {
    canActivate: [authGuard],
    component: OverviewComponent,
    data: { role: ['admin', 'manager'] },
    path: 'overview',
    title: 'Pārskats',
  },
  {
    canActivate: [loginGuard],
    component: LoginComponent,
    path: 'login',
    title: 'Pieslēgties',
  },
  {
    canActivate: [loginGuard],
    component: UnauthorizedMenuComponent,
    path: 'unauthorized',
    title: 'Neautorizēts lietotājs',
  },
];
